import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { TransactionIndexResponse } from '@/repositories/generated';

// 取引履歴DL CSV（101_transaction_history_daily）の実データを元にしたモック。
// 取引詳細区分ごとの設定規則（取消系は外部取引IDなし、購入・残高調整・失効は加盟店情報なし、
// 調整額は決済・購入系のみ設定で残高調整・失効は空、等）はファイル設計書 #02-01 のマトリクスに準拠
const content: TransactionIndexResponse[] = [
  // コード決済 / ハウスプリペイド決済（商品券なし・調整額0）
  {
    completedAt: '2026-06-08T00:00:00+09:00',
    transactionId: '260608185500699864',
    serviceTransactionId: '20260608000000000000000000000006',
    transactionType: 'CODE_PAYMENT',
    transactionDetailType: 'HOUSE_PREPAID_SETTLEMENT',
    amount: 2200,
    adjustmentAmount: 0,
    specifiedAmount: 2200,
    status: 'SUCCESS',
    walletUserId: 658,
    externalWalletUserId: '5352f9df41c14ec7bdd8e58b10d30b1a',
    companyName: '株式会社IC商店',
    shopName: 'IC商店阿蘇店',
    terminalName: 'IC商店阿蘇店レジ1',
    walletServiceName: 'くまモン!Pay101',
    transactionBreakDown: {},
  },
  // 商品券残高失効（加盟店情報・調整額なし）
  {
    completedAt: '2026-06-08T10:00:00+09:00',
    transactionId: '500026060800000001',
    serviceTransactionId: undefined,
    transactionType: 'GIFT_BALANCE_EXPIRED',
    transactionDetailType: 'BALANCE_EXPIRED',
    amount: 500,
    status: 'SUCCESS',
    walletUserId: 659,
    externalWalletUserId: '5fb14db523874dacbcf54934b65dc276',
    walletServiceName: 'くまモン!Pay101',
    giftIssuerId: '1',
    giftIssuerName: 'くまもとデジタル推進協会',
    giftBusinessId: '1',
    giftBusinessName: '熊本市デジタル商品券',
    giftName: '共通利用券',
    transactionBreakDown: {
      prepaidValueAmount: 500,
    },
  },
  // コード決済 / ハウスプリペイド決済（取消済み）
  {
    completedAt: '2026-06-08T11:09:24+09:00',
    transactionId: '260609110924597552',
    serviceTransactionId: '20260609000000000000000000000002',
    transactionType: 'CODE_PAYMENT',
    transactionDetailType: 'HOUSE_PREPAID_SETTLEMENT',
    amount: 3000,
    adjustmentAmount: 0,
    specifiedAmount: 3000,
    status: 'CANCELED',
    walletUserId: 658,
    externalWalletUserId: '5352f9df41c14ec7bdd8e58b10d30b1a',
    companyName: '株式会社IC商店',
    shopName: 'IC商店阿蘇店',
    terminalName: 'IC商店阿蘇店レジ1',
    walletServiceName: 'くまモン!Pay101',
    transactionBreakDown: {},
  },
  // コード決済 / 商品券決済（取消済み・実決済額0）
  {
    completedAt: '2026-06-08T11:14:29+09:00',
    transactionId: '260609111429647715',
    serviceTransactionId: '20260609000000000000000000000006',
    transactionType: 'CODE_PAYMENT',
    transactionDetailType: 'GIFT_CERTIFICATE_SETTLEMENT',
    amount: 0,
    adjustmentAmount: 900,
    specifiedAmount: 900,
    status: 'CANCELED',
    walletUserId: 658,
    externalWalletUserId: '5352f9df41c14ec7bdd8e58b10d30b1a',
    companyName: '株式会社IC商店',
    shopName: 'IC商店阿蘇店',
    terminalName: 'IC商店阿蘇店レジ1',
    walletServiceName: 'くまモン!Pay101',
    giftIssuerId: '3',
    giftIssuerName: 'ABI用商品券事業者1',
    giftBusinessId: '7',
    giftBusinessName: 'ABI用商品券事業01',
    giftName: 'ABI用商品券面01-01',
    transactionBreakDown: {
      prepaidValueAmount: 650,
      bonusValueAmount: 250,
    },
  },
  // コード決済 / 商品券併用決済（取消済み）
  {
    completedAt: '2026-06-08T11:15:07+09:00',
    transactionId: '260609111507235913',
    serviceTransactionId: '20260609000000000000000000000007',
    transactionType: 'CODE_PAYMENT',
    transactionDetailType: 'SPLIT_SETTLEMENT',
    amount: 150,
    adjustmentAmount: 350,
    specifiedAmount: 500,
    status: 'CANCELED',
    walletUserId: 658,
    externalWalletUserId: '5352f9df41c14ec7bdd8e58b10d30b1a',
    companyName: '株式会社IC商店',
    shopName: 'IC商店阿蘇店',
    terminalName: 'IC商店阿蘇店レジ1',
    walletServiceName: 'くまモン!Pay101',
    giftIssuerId: '3',
    giftIssuerName: 'ABI用商品券事業者1',
    giftBusinessId: '7',
    giftBusinessName: 'ABI用商品券事業01',
    giftName: 'ABI用商品券面01-01',
    transactionBreakDown: {
      prepaidValueAmount: 350,
      bonusValueAmount: 0,
    },
  },
  // コード決済取消 / ハウスプリペイド決済取消（取消側は外部取引IDなし）
  {
    completedAt: '2026-06-08T11:22:14+09:00',
    transactionId: '260609112213988569',
    serviceTransactionId: undefined,
    transactionType: 'CODE_PAYMENT_CANCEL',
    transactionDetailType: 'HOUSE_PREPAID_SETTLEMENT_CANCEL',
    amount: 3000,
    adjustmentAmount: 0,
    specifiedAmount: 3000,
    status: 'SUCCESS',
    walletUserId: 658,
    externalWalletUserId: '5352f9df41c14ec7bdd8e58b10d30b1a',
    companyName: '株式会社IC商店',
    shopName: 'IC商店阿蘇店',
    terminalName: 'IC商店阿蘇店レジ1',
    walletServiceName: 'くまモン!Pay101',
    transactionBreakDown: {},
  },
  // コード決済取消 / 商品券併用決済取消
  {
    completedAt: '2026-06-08T11:25:55+09:00',
    transactionId: '260609112555653304',
    serviceTransactionId: undefined,
    transactionType: 'CODE_PAYMENT_CANCEL',
    transactionDetailType: 'SPLIT_SETTLEMENT_CANCEL',
    amount: 150,
    adjustmentAmount: 350,
    specifiedAmount: 500,
    status: 'SUCCESS',
    walletUserId: 658,
    externalWalletUserId: '5352f9df41c14ec7bdd8e58b10d30b1a',
    companyName: '株式会社IC商店',
    shopName: 'IC商店阿蘇店',
    terminalName: 'IC商店阿蘇店レジ1',
    walletServiceName: 'くまモン!Pay101',
    giftIssuerId: '3',
    giftIssuerName: 'ABI用商品券事業者1',
    giftBusinessId: '7',
    giftBusinessName: 'ABI用商品券事業01',
    giftName: 'ABI用商品券面01-01',
    transactionBreakDown: {
      prepaidValueAmount: 350,
      bonusValueAmount: 0,
    },
  },
  // コード決済取消 / 商品券決済取消
  {
    completedAt: '2026-06-08T11:26:33+09:00',
    transactionId: '260609112633503051',
    serviceTransactionId: undefined,
    transactionType: 'CODE_PAYMENT_CANCEL',
    transactionDetailType: 'GIFT_CERTIFICATE_SETTLEMENT_CANCEL',
    amount: 0,
    adjustmentAmount: 900,
    specifiedAmount: 900,
    status: 'SUCCESS',
    walletUserId: 658,
    externalWalletUserId: '5352f9df41c14ec7bdd8e58b10d30b1a',
    companyName: '株式会社IC商店',
    shopName: 'IC商店阿蘇店',
    terminalName: 'IC商店阿蘇店レジ1',
    walletServiceName: 'くまモン!Pay101',
    giftIssuerId: '3',
    giftIssuerName: 'ABI用商品券事業者1',
    giftBusinessId: '7',
    giftBusinessName: 'ABI用商品券事業01',
    giftName: 'ABI用商品券面01-01',
    transactionBreakDown: {
      prepaidValueAmount: 650,
      bonusValueAmount: 250,
    },
  },
  // 商品券残高調整（加算・前払バリュー）
  {
    completedAt: '2026-06-08T13:09:50+09:00',
    transactionId: '600026060813095080',
    serviceTransactionId: undefined,
    transactionType: 'GIFT_BALANCE_ADJUSTMENT_IN',
    transactionDetailType: 'GIFT_BALANCE_ADJUSTMENT_IN',
    amount: 100,
    status: 'SUCCESS',
    walletUserId: 658,
    externalWalletUserId: '5352f9df41c14ec7bdd8e58b10d30b1a',
    walletServiceName: 'くまモン!Pay101',
    giftIssuerId: '3',
    giftIssuerName: 'ABI用商品券事業者1',
    giftBusinessId: '7',
    giftBusinessName: 'ABI用商品券事業01',
    giftName: 'ABI用商品券面01-01',
    transactionBreakDown: {
      prepaidValueAmount: 100,
    },
  },
  // 商品券残高調整（減算・前払バリュー）
  {
    completedAt: '2026-06-08T13:10:12+09:00',
    transactionId: '600026060813101291',
    serviceTransactionId: undefined,
    transactionType: 'GIFT_BALANCE_ADJUSTMENT_OUT',
    transactionDetailType: 'GIFT_BALANCE_ADJUSTMENT_OUT',
    amount: 100,
    status: 'SUCCESS',
    walletUserId: 658,
    externalWalletUserId: '5352f9df41c14ec7bdd8e58b10d30b1a',
    walletServiceName: 'くまモン!Pay101',
    giftIssuerId: '3',
    giftIssuerName: 'ABI用商品券事業者1',
    giftBusinessId: '7',
    giftBusinessName: 'ABI用商品券事業01',
    giftName: 'ABI用商品券面01-01',
    transactionBreakDown: {
      prepaidValueAmount: 100,
    },
  },
  // 商品券残高調整（加算・ボーナスバリュー）
  {
    completedAt: '2026-06-08T13:10:53+09:00',
    transactionId: '600026060813105355',
    serviceTransactionId: undefined,
    transactionType: 'GIFT_BALANCE_ADJUSTMENT_IN',
    transactionDetailType: 'GIFT_BALANCE_ADJUSTMENT_IN',
    amount: 100,
    status: 'SUCCESS',
    walletUserId: 658,
    externalWalletUserId: '5352f9df41c14ec7bdd8e58b10d30b1a',
    walletServiceName: 'くまモン!Pay101',
    giftIssuerId: '3',
    giftIssuerName: 'ABI用商品券事業者1',
    giftBusinessId: '7',
    giftBusinessName: 'ABI用商品券事業01',
    giftName: 'ABI用商品券面01-01',
    transactionBreakDown: {
      bonusValueAmount: 100,
    },
  },
  // 商品券残高調整（減算・ボーナスバリュー）
  {
    completedAt: '2026-06-08T13:11:04+09:00',
    transactionId: '600026060813110399',
    serviceTransactionId: undefined,
    transactionType: 'GIFT_BALANCE_ADJUSTMENT_OUT',
    transactionDetailType: 'GIFT_BALANCE_ADJUSTMENT_OUT',
    amount: 100,
    status: 'SUCCESS',
    walletUserId: 658,
    externalWalletUserId: '5352f9df41c14ec7bdd8e58b10d30b1a',
    walletServiceName: 'くまモン!Pay101',
    giftIssuerId: '3',
    giftIssuerName: 'ABI用商品券事業者1',
    giftBusinessId: '7',
    giftBusinessName: 'ABI用商品券事業01',
    giftName: 'ABI用商品券面01-01',
    transactionBreakDown: {
      bonusValueAmount: 100,
    },
  },
  // 商品券残高調整（加算・別事業者）
  {
    completedAt: '2026-06-08T15:59:47+09:00',
    transactionId: '600026060815594777',
    serviceTransactionId: undefined,
    transactionType: 'GIFT_BALANCE_ADJUSTMENT_IN',
    transactionDetailType: 'GIFT_BALANCE_ADJUSTMENT_IN',
    amount: 100,
    status: 'SUCCESS',
    walletUserId: 671,
    externalWalletUserId: '31a0f6794a964956b690ec50c85ec4f3',
    walletServiceName: 'くまモン!Pay101',
    giftIssuerId: '1',
    giftIssuerName: 'くまもとデジタル推進協会',
    giftBusinessId: '4',
    giftBusinessName: '自由枠事業A',
    giftName: '自由枠券面A',
    transactionBreakDown: {
      prepaidValueAmount: 100,
    },
  },
  // コード決済取消 / 商品券決済取消（高額）
  {
    completedAt: '2026-06-08T18:18:13+09:00',
    transactionId: '260608181813738604',
    serviceTransactionId: undefined,
    transactionType: 'CODE_PAYMENT_CANCEL',
    transactionDetailType: 'GIFT_CERTIFICATE_SETTLEMENT_CANCEL',
    amount: 0,
    adjustmentAmount: 12000,
    specifiedAmount: 12000,
    status: 'SUCCESS',
    walletUserId: 681,
    externalWalletUserId: 'f03bcc7b10774696ac07f6dd63fc0029',
    companyName: '株式会社IC商店',
    shopName: 'IC商店阿蘇店',
    terminalName: 'IC商店阿蘇店レジ1',
    walletServiceName: 'くまモン!Pay101',
    giftIssuerId: '1',
    giftIssuerName: 'くまもとデジタル推進協会',
    giftBusinessId: '4',
    giftBusinessName: '自由枠事業A',
    giftName: '自由枠券面A',
    transactionBreakDown: {
      prepaidValueAmount: 5000,
      bonusValueAmount: 7000,
    },
  },
  // 商品券購入 / ハウスプリペイド商品券購入（加盟店情報なし・調整額0）
  {
    completedAt: '2026-06-08T18:46:55+09:00',
    transactionId: '260608184655114894',
    serviceTransactionId: '20260413100000000000000000000010',
    transactionType: 'PURCHASE_GIFT_CERTIFICATE',
    transactionDetailType: 'HOUSE_PREPAID_PURCHASE_GIFT',
    amount: 1000,
    adjustmentAmount: 0,
    specifiedAmount: 1000,
    status: 'SUCCESS',
    walletUserId: 658,
    externalWalletUserId: '5352f9df41c14ec7bdd8e58b10d30b1a',
    walletServiceName: 'くまモン!Pay101',
    giftIssuerId: '3',
    giftIssuerName: 'ABI用商品券事業者1',
    giftBusinessId: '7',
    giftBusinessName: 'ABI用商品券事業01',
    giftName: 'ABI用商品券面01-01',
    transactionBreakDown: {},
  },
  // コード決済 / 商品券決済（実決済額0）
  {
    completedAt: '2026-06-08T18:48:39+09:00',
    transactionId: '260608184839701667',
    serviceTransactionId: '20260608000000000000000000000001',
    transactionType: 'CODE_PAYMENT',
    transactionDetailType: 'GIFT_CERTIFICATE_SETTLEMENT',
    amount: 0,
    adjustmentAmount: 800,
    specifiedAmount: 800,
    status: 'SUCCESS',
    walletUserId: 658,
    externalWalletUserId: '5352f9df41c14ec7bdd8e58b10d30b1a',
    companyName: '株式会社IC商店',
    shopName: 'IC商店阿蘇店',
    terminalName: 'IC商店阿蘇店レジ1',
    walletServiceName: 'くまモン!Pay101',
    giftIssuerId: '3',
    giftIssuerName: 'ABI用商品券事業者1',
    giftBusinessId: '7',
    giftBusinessName: 'ABI用商品券事業01',
    giftName: 'ABI用商品券面01-01',
    transactionBreakDown: {
      prepaidValueAmount: 550,
      bonusValueAmount: 250,
    },
  },
  // コード決済 / 商品券併用決済
  {
    completedAt: '2026-06-08T18:50:37+09:00',
    transactionId: '260608185037108826',
    serviceTransactionId: '20260608000000000000000000000002',
    transactionType: 'CODE_PAYMENT',
    transactionDetailType: 'SPLIT_SETTLEMENT',
    amount: 1050,
    adjustmentAmount: 450,
    specifiedAmount: 1500,
    status: 'SUCCESS',
    walletUserId: 658,
    externalWalletUserId: '5352f9df41c14ec7bdd8e58b10d30b1a',
    companyName: '株式会社IC商店',
    shopName: 'IC商店阿蘇店',
    terminalName: 'IC商店阿蘇店レジ1',
    walletServiceName: 'くまモン!Pay101',
    giftIssuerId: '3',
    giftIssuerName: 'ABI用商品券事業者1',
    giftBusinessId: '7',
    giftBusinessName: 'ABI用商品券事業01',
    giftName: 'ABI用商品券面01-01',
    transactionBreakDown: {
      prepaidValueAmount: 450,
      bonusValueAmount: 0,
    },
  },
  // コード決済 / ハウスプリペイド決済
  {
    completedAt: '2026-06-08T18:54:15+09:00',
    transactionId: '260608185415085230',
    serviceTransactionId: '20260608000000000000000000000004',
    transactionType: 'CODE_PAYMENT',
    transactionDetailType: 'HOUSE_PREPAID_SETTLEMENT',
    amount: 2000,
    adjustmentAmount: 0,
    specifiedAmount: 2000,
    status: 'SUCCESS',
    walletUserId: 658,
    externalWalletUserId: '5352f9df41c14ec7bdd8e58b10d30b1a',
    companyName: '株式会社IC商店',
    shopName: 'IC商店阿蘇店',
    terminalName: 'IC商店阿蘇店レジ1',
    walletServiceName: 'くまモン!Pay101',
    transactionBreakDown: {},
  },
  // コード決済 / ハウスプリペイド決済
  {
    completedAt: '2026-06-08T18:54:43+09:00',
    transactionId: '260608185443360705',
    serviceTransactionId: '20260608000000000000000000000005',
    transactionType: 'CODE_PAYMENT',
    transactionDetailType: 'HOUSE_PREPAID_SETTLEMENT',
    amount: 2100,
    adjustmentAmount: 0,
    specifiedAmount: 2100,
    status: 'SUCCESS',
    walletUserId: 658,
    externalWalletUserId: '5352f9df41c14ec7bdd8e58b10d30b1a',
    companyName: '株式会社IC商店',
    shopName: 'IC商店阿蘇店',
    terminalName: 'IC商店阿蘇店レジ1',
    walletServiceName: 'くまモン!Pay101',
    transactionBreakDown: {},
  },
  // コード決済 / ハウスプリペイド決済（高額・日跨ぎ境界）
  {
    completedAt: '2026-06-08T23:59:59+09:00',
    transactionId: '260608185613141583',
    serviceTransactionId: '20260608000000000000000000000007',
    transactionType: 'CODE_PAYMENT',
    transactionDetailType: 'HOUSE_PREPAID_SETTLEMENT',
    amount: 9999999,
    adjustmentAmount: 0,
    specifiedAmount: 9999999,
    status: 'SUCCESS',
    walletUserId: 658,
    externalWalletUserId: '5352f9df41c14ec7bdd8e58b10d30b1a',
    companyName: '株式会社IC商店',
    shopName: 'IC商店阿蘇店',
    terminalName: 'IC商店阿蘇店レジ1',
    walletServiceName: 'くまモン!Pay101',
    transactionBreakDown: {},
  },
  // 以下はCSV実データに含まれない区分・ステータスの表示確認用の補完データ
  // （セルフチャージ系の取引詳細区分、FAILURE/WAITING_AUTHステータス）
  // セルフチャージ / BankPayチャージ（調整額・加盟店情報は空）
  {
    completedAt: '2026-06-08T08:30:00+09:00',
    transactionId: '260608083000000101',
    serviceTransactionId: '20260608000000000000000000000101',
    transactionType: 'SELF_CHARGE',
    transactionDetailType: 'BANK_PAY_CHARGE',
    amount: 5000,
    status: 'SUCCESS',
    walletUserId: 658,
    externalWalletUserId: '5352f9df41c14ec7bdd8e58b10d30b1a',
    walletServiceName: 'くまモン!Pay101',
    transactionBreakDown: {
      directBankAmount: 5000,
    },
  },
  // セルフチャージ / ポイントチャージ
  {
    completedAt: '2026-06-08T08:35:00+09:00',
    transactionId: '260608083500000102',
    serviceTransactionId: '20260608000000000000000000000102',
    transactionType: 'SELF_CHARGE',
    transactionDetailType: 'POINT_CHARGE',
    amount: 1000,
    status: 'SUCCESS',
    walletUserId: 659,
    externalWalletUserId: '5fb14db523874dacbcf54934b65dc276',
    walletServiceName: 'くまモン!Pay101',
    transactionBreakDown: {
      basicPointAmount: 1000,
    },
  },
  // セルフチャージ / ApplePayチャージ
  {
    completedAt: '2026-06-08T08:40:00+09:00',
    transactionId: '260608084000000103',
    serviceTransactionId: '20260608000000000000000000000103',
    transactionType: 'SELF_CHARGE',
    transactionDetailType: 'APPLE_PAY_CHARGE',
    amount: 3000,
    status: 'SUCCESS',
    walletUserId: 671,
    externalWalletUserId: '31a0f6794a964956b690ec50c85ec4f3',
    walletServiceName: 'くまモン!Pay101',
    transactionBreakDown: {
      creditCardAmount: 3000,
    },
  },
  // セルフチャージ / BankPayチャージ（認証待ち）
  {
    completedAt: '2026-06-08T08:45:00+09:00',
    transactionId: '260608084500000104',
    serviceTransactionId: '20260608000000000000000000000104',
    transactionType: 'SELF_CHARGE',
    transactionDetailType: 'BANK_PAY_CHARGE',
    amount: 2000,
    status: 'WAITING_AUTH',
    walletUserId: 658,
    externalWalletUserId: '5352f9df41c14ec7bdd8e58b10d30b1a',
    walletServiceName: 'くまモン!Pay101',
    transactionBreakDown: {},
  },
  // コード決済 / ハウスプリペイド決済（取引失敗・赤字表示確認用）
  {
    completedAt: '2026-06-08T09:10:00+09:00',
    transactionId: '260608091000000105',
    serviceTransactionId: '20260608000000000000000000000105',
    transactionType: 'CODE_PAYMENT',
    transactionDetailType: 'HOUSE_PREPAID_SETTLEMENT',
    amount: 1500,
    adjustmentAmount: 0,
    specifiedAmount: 1500,
    status: 'FAILURE',
    walletUserId: 658,
    externalWalletUserId: '5352f9df41c14ec7bdd8e58b10d30b1a',
    companyName: '株式会社IC商店',
    shopName: 'IC商店阿蘇店',
    terminalName: 'IC商店阿蘇店レジ1',
    walletServiceName: 'くまモン!Pay101',
    transactionBreakDown: {},
  },
  // コード決済 / 商品券決済（取引失敗・商品券列＋赤字表示の組み合わせ確認用）
  {
    completedAt: '2026-06-08T09:20:00+09:00',
    transactionId: '260608092000000106',
    serviceTransactionId: '20260608000000000000000000000106',
    transactionType: 'CODE_PAYMENT',
    transactionDetailType: 'GIFT_CERTIFICATE_SETTLEMENT',
    amount: 0,
    adjustmentAmount: 600,
    specifiedAmount: 600,
    status: 'FAILURE',
    walletUserId: 659,
    externalWalletUserId: '5fb14db523874dacbcf54934b65dc276',
    companyName: '株式会社IC商店',
    shopName: 'IC商店阿蘇店',
    terminalName: 'IC商店阿蘇店レジ1',
    walletServiceName: 'くまモン!Pay101',
    giftIssuerId: '1',
    giftIssuerName: 'くまもとデジタル推進協会',
    giftBusinessId: '1',
    giftBusinessName: '熊本市デジタル商品券',
    giftName: '共通利用券',
    transactionBreakDown: {
      prepaidValueAmount: 400,
      bonusValueAmount: 200,
    },
  },
];

const loopContent = new Array<string>(50)
  .fill('')
  .map((_, i) => content[i % content.length]);

export const transaction = http.get(
  createMockEndpoint('/transaction'),
  async ({ request }) => {
    const url = new URL(request.url);
    await delay(500);
    const detailTypesExists = url.searchParams.get('transactionTypes') ?? '';
    const statusExists = url.searchParams.get('status') ?? '';
    const shopExists = url.searchParams.get('shopNames') ?? '';
    const externalShopExists = url.searchParams.get('externalShopId') ?? '';
    const acquirerExists = url.searchParams.get('acquirerNames') ?? '';
    const companyExists = url.searchParams.get('companyNames') ?? '';

    if (detailTypesExists || statusExists || shopExists || externalShopExists || acquirerExists || companyExists) {
      return HttpResponse.json({
        content: loopContent.slice(3, 25),
        pageable: {
          sort: {
            empty: true,
            sorted: false,
            unsorted: true,
          },
          offset: 0,
          pageNumber: 0,
          pageSize: 20,
          paged: true,
          unpaged: false,
        },
        last: true,
        totalPages: 1,
        totalElements: 20,
        size: 20,
        number: 0,
        sort: {
          empty: true,
          sorted: false,
          unsorted: true,
        },
        first: true,
        numberOfElements: 20,
        empty: false,
      }, { status: 200 });
    }
    // クエリパラメータなし
    return HttpResponse.json({
      content: loopContent,
      pageable: {
        sort: {
          empty: true,
          sorted: false,
          unsorted: true,
        },
        offset: 0,
        pageNumber: 0,
        pageSize: 20,
        paged: true,
        unpaged: false,
      },
      last: true,
      totalPages: 1,
      totalElements: 50,
      size: 50,
      number: 0,
      sort: {
        empty: true,
        sorted: false,
        unsorted: true,
      },
      first: true,
      numberOfElements: 50,
      empty: false,
    }, { status: 200 });
  },
);
